import { bind } from 'bind-decorator';
import { Show } from 'bz-core-controls';
import React from 'react';
import { ClinicalBaseControl } from '../clinical-base-control';
import ReadOnly from '../read-only';
import Label from './controls/label';
import TimeLabel from './controls/time-label';
import TimePicker from './controls/time-picker';

class ClinicalTimePicker extends React.Component {
  time = React.createRef();

  render() {
    const { inline, label, readOnly, value } = this.props;

    let control;
    if (!readOnly) {
      const { errored, value, warning, onChange } = this.props;
      control = (
        <TimePicker
          ref={this.time}
          errored={errored}
          warning={warning}
          value={value}
          onChange={onChange}
        />
      );
    } else {
      control = (
        <ReadOnly
          forceNotSpecified={!value}
          isDate={true}
          value={<TimeLabel value={value} skipUtc={true} />}
        />
      );
    }

    return (
      <span>
        <Show if={!this.props.hideLabel}>
          <Label inline={inline} value={label} onClick={this.onClick} />
        </Show>
        {control}
      </span>
    );
  }

  @bind
  onClick(e) {
    const { time } = this;
    if (!!time.current) {
      time.current.open();
    }
  }
}

export { ClinicalTimePicker };
export default ClinicalBaseControl(ClinicalTimePicker);
